import { render, staticRenderFns } from "./VendorStats.vue?vue&type=template&id=f64b3158&lang=pug&"
import script from "./VendorStats.vue?vue&type=script&lang=js&"
export * from "./VendorStats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports